import React from 'react'
import { Button, Modal, List, Image, Form, Icon, GridRow, GridColumn, Grid } from 'semantic-ui-react'
import {createAPIClient} from '../../../../../services/api'

const modalStyle = { marginTop: '100px', marginLeft: 'auto', marginRight: 'auto' }

class CommentView extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      location: undefined,
      issueId: undefined,
      commentId: undefined,
      comment: undefined,
      isOpen: false,
    }
    this.timer = undefined
    this.input = React.createRef()
    this.getComment = this.getComment.bind(this)
  }
  getComment () {
    if (!this.state.issueId) {
      return
    }
    const api = createAPIClient()
    const _self = this
    if (!this.state.commentId) {
      api
        .post('/api/comments', {location: this.state.location, issue: this.state.issueId})
        .then(function (result) {
          let comment = result.data.response
          _self.setState({
            comment: comment,
            commentId: comment._id
          })
        })
    } else {
      api
        .get(`/api/comments/${_self.state.commentId}`)
        .then(function (result) {
          let comment = result.data.response
          _self.setState({
            comment: comment,
            commentId: comment._id
          })
        })
    }
  }
  sendMessage () {
    if (!this.state.commentId) {
      return
    }

    const message = this.input.current.value
    const api = createAPIClient()
    const _self = this
    api
      .put(`/api/comments/${this.state.commentId}`, {message: message})
      .then(function (result) {
        _self.getComment()
        _self.input.current.value = ''
      })
  }
  componentDidUpdate (prevProps, prevState, snapshot) {
    if (prevState.issueId !== this.props.issueId) {
      this.setState({
        issueId: this.props.issueId,
        commentId: this.props.commentId,
        location: this.props.location,
        isOpen: this.props.isOpen
      })
      if (this.props.isOpen) {
        this.getComment()
        const _self = this
        if (this.timer) {
          clearInterval(this.timer)
        }
        this.timer = setInterval(function () {
          _self.getComment()
        }, 6000)
      }
    }
  }
  onClose () {
    this.props.onClose()
    clearInterval(this.timer)
    this.timer = undefined
  }

  getMessageItem (message) {
    return (
      <List.Item>
        <List.Content>
          <List.Header as='a'>
            <Image avatar src='/icons/person_64.png' />
            {message.user_name}
          </List.Header>
          <List.Description>
            {message.text}
          </List.Description>
        </List.Content>
      </List.Item>
    )
  }

  render () {
    const messageList = (
      <List relaxed>
        {
          this.state.comment && this.state.comment.messages.map(e => {
            return this.getMessageItem(e)
          })
        }
      </List>
    )
    const sendMessage = (
      <Form>
        <Grid>
          <GridRow>
            <GridColumn width={14}>
              <Form.Field>
                <input ref={this.input} placeholder={'Your message'} />
              </Form.Field>
            </GridColumn>
            <GridColumn width={1}>
              <Button onClick={this.sendMessage.bind(this)} icon>
                <Icon name='send' />
              </Button>
            </GridColumn>

          </GridRow>
        </Grid>
      </Form>
    )

    const modal = (
      <Modal open={this.state.isOpen} style={modalStyle}>
        <Modal.Header style={{ overflow: 'hidden' }}>
          Comments
        </Modal.Header>
        <Modal.Content scrolling>
          <Modal.Description>
            {messageList}
            {sendMessage}
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          <Button icon='check' content='Close' onClick={this.onClose.bind(this)} />
        </Modal.Actions>
      </Modal>
    )

    return modal
  }
}

export default CommentView




// WEBPACK FOOTER //
// ./src/pages/issues/overview/components/commentview/index.js